import Frames from "@frog/source/utility/Frames.js"

export default {
    "static": require("./paladin-idle-0.png"),
    "idle": {
        "frames": Frames.run({
            "tweentime": 100,
            "images": [
                require("./paladin-idle-0.png"),
                require("./paladin-idle-0.png"),
                require("./paladin-idle-0.png"),
                require("./paladin-idle-0.png"),
                require("./paladin-idle-0.png"),
                require("./paladin-idle-0.png"),
                require("./paladin-idle-0.png"),
                require("./paladin-idle-0.png"),
                require("./paladin-idle-1.png"),
                require("./paladin-idle-2.png"),
                require("./paladin-idle-3.png"),
                require("./paladin-idle-4.png"),
                require("./paladin-idle-5.png"),
                require("./paladin-idle-6.png"),
                require("./paladin-idle-7.png"),
                require("./paladin-idle-7.png"),
                require("./paladin-idle-7.png"),
                require("./paladin-idle-7.png"),
            ]
        })
    },
    "ready": {
        "frames": Frames.run({
            "tweentime": 80,
            "images": [
                require("./paladin-selected-3.png"),
                require("./paladin-selected-4.png"),
                require("./paladin-selected-5.png"),
                require("./paladin-selected-6.png"),
                require("./paladin-selected-6.png"),
                require("./paladin-selected-6.png"),
                require("./paladin-selected-6.png"),
                require("./paladin-selected-6.png"),
                require("./paladin-selected-6.png"),
                require("./paladin-selected-6.png"),
                require("./paladin-selected-6.png"),
                require("./paladin-selected-7.png"),
                require("./paladin-selected-7.png"),
                require("./paladin-selected-7.png"),
                require("./paladin-selected-7.png"),
                require("./paladin-selected-0.png"),
                require("./paladin-selected-0.png"),
                require("./paladin-selected-0.png"),
                require("./paladin-selected-0.png"),
                require("./paladin-selected-0.png"),
                require("./paladin-selected-0.png"),
                require("./paladin-selected-1.png"),
                require("./paladin-selected-2.png"),
                require("./paladin-selected-2.png"),
            ]
        })
    },
}
